import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdDeleteEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdDeleteEventDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdDeleteEvent) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdDeleteEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdDeleteEvent {
  roomId: RoomId;
}
